document.addEventListener("DOMContentLoaded", function () {
  const image2 = document.querySelector(".landing__image--2");
  const grid = document.querySelector(".landing__grid");

  if (!image2 || !grid) return;

  function syncGridHeight() {
    if (window.innerWidth >= 1280) {
      const rect = image2.getBoundingClientRect();
      grid.style.height = `${rect.height}px`;
    } else {
      grid.style.height = ""; // reset on smaller screens
    }
  }

  // ResizeObserver to detect size change of the image
  const observer = new ResizeObserver(() => {
    syncGridHeight();
  });

  observer.observe(image2);

  // Sync on window resize
  window.addEventListener("resize", syncGridHeight);

  // Sync once image is loaded (if it's lazy-loaded)
  if (!image2.complete) {
    image2.addEventListener("load", syncGridHeight);
  } else {
    syncGridHeight(); // Already loaded
  }
});
